import { useEffect } from 'react';

import { shallow } from 'zustand/shallow';

import { useConditionBuilderStoreApi } from '../store';

export function useSubscribeConditionChange() {
  const store = useConditionBuilderStoreApi();

  useEffect(() => {
    const unsubscribe = store.subscribe((state, prevState) => {
      const isShallow = shallow(state.condition, prevState.condition);

      if (isShallow) return;

      store.getState().handleConditionChange(state.condition);
    });

    return () => {
      unsubscribe();
    };
  }, [store]);
}
